import { useI18n } from "i18n";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { ReachabilityDetection } from "modules/systemCheck/components/ReachabilityDetection";
import { DetectionTestBase } from "../DetectionTestBase";
import { FirewallDetectionError } from "../FirewallDetectionError";
import { ReachabilityTestResult } from "../types";

interface Props {
  isLoading: boolean;
  isFirebaseStorageAccessible: boolean;
  reachabilityResult: ReachabilityTestResult;
  hasDivider?: boolean;
}

export const FirewallDetection = ({
  isLoading,
  isFirebaseStorageAccessible,
  reachabilityResult,
  hasDivider = true,
}: Props): JSX.Element => {
  const { t } = useI18n(["micCamCheck", "url"]);
  const isSuccessful =
    isFirebaseStorageAccessible &&
    Object.values(reachabilityResult).every((result) => result.isSuccessful);

  return (
    <DetectionTestBase
      testName={
        !isSuccessful && !isLoading
          ? t("micCamCheck:network.check.failed")
          : t("micCamCheck:network")
      }
      testResult={
        <>
          <ReachabilityDetection reachabilityResult={reachabilityResult} />
          {isSuccessful ? (
            <Typography variant="body1">
              {t("micCamCheck:network.connection.looks.good")}
            </Typography>
          ) : (
            <FirewallDetectionError
              isFirebaseStorageAccessible={isFirebaseStorageAccessible}
            />
          )}
        </>
      }
      troubleShootLink={t("url:troubleshoot.firewall")}
      showTroubleshootLink={!isSuccessful}
      isRecommendation
      hasDivider={hasDivider}
      isLoading={isLoading}
    />
  );
};
